import * as React from 'react';
import { useSelector } from 'react-redux';

import { getCfdOptions } from '~/renderer/store/cfd/selectors';
import analytics from '~/renderer/utils/analytics';
import { getConfig } from '~/renderer/utils/config';

import type { Options } from '~/renderer/store/cfd/types';
import type { AppState } from '~/renderer/store/types';

export const useAnalytics = () => {
  const { accountId, shopId, registerId, userId } =
    useSelector<AppState, Options>(getCfdOptions) || getConfig(['options'])?.options || {};

  React.useEffect(() => {
    if (accountId) {
      analytics?.setUserId(accountId);

      analytics?.setUserProperties({
        accountId,
        shopId,
        registerId,
        userId,
      });
    }
  }, [accountId, shopId, registerId, userId]);

  return {};
};
